// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "64ea2895ba3859d9cffc2725cb7e8f472b3e0058/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};